// ValueContext.tsx
import React, { createContext, useContext, useState, FC, ReactNode } from 'react';

interface ValueContextProps {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>; // Declare the type for setValue
  handleClick: () => void;
}

const ValueContext = createContext<ValueContextProps | undefined>(undefined);

interface ValueProviderProps {
  children: ReactNode;
}

export const ValueProvider: FC<ValueProviderProps> = ({ children }) => {
  const [value, setValue] = useState<number>(0);

  const handleClick = () => {
    setValue(1);
  };

  return (
    <ValueContext.Provider value={{ value, setValue, handleClick }}>
      {children}
    </ValueContext.Provider>
  );
};

export const useValue = (): ValueContextProps => {
  const context = useContext(ValueContext);
  if (!context) {
    throw new Error('useValue must be used within a ValueProvider');
  }
  return context;
};
